import React from 'react';
import styled from 'styled-components';
import ArrowBack from '@material-ui/icons/ArrowBack';

const HeaderContainer = styled.div`
  padding: 0.5rem 5.9375rem 0.5rem 5.9375rem;
  background: #37474f;
  display: flex;
  justify-content: space-between;
`;

const ImagesContainer = styled.div`
  border: 1px solid #000;
  width: 3.5rem;
  height: 3.5rem;
`;

const HeadingContainer = styled.div`
  margin-left: 1rem;
  height: 3.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const Title = styled.h2`
  color: #fff;
  font-size: 1.5rem;
`;
const Location = styled.h3`
  color: #fff;
  font-size: 0.75rem;
`;

const IssuedByContainer = styled.div`
  display: flex;
  align-items: flex-end;
  padding-bottom: 5px;
`;

const IssuedByTitle = styled.span`
  font-weight: 600;
  font-size: 0.875rem;
  color: #fff;
  font-family: Times, 'Times New Roman', Times32;
`;
const IssuedBy = styled.span`
  font-size: 0.875rem;
  color: #fff;
  font-family: Times, 'Times New Roman', Times32;
`;

const Wrapper = styled.div`
  display: flex;
`;
const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  color: white;
  &:first-child {
    cursor: pointer;
  }
`;

const Header = ({ ticketData, history }) => (
  <HeaderContainer>
    <Wrapper>
      <ArrowWrapper>
        <ArrowBack onClick={() => history.goBack()} />
      </ArrowWrapper>
      {/* <ImagesContainer /> */}

      <HeadingContainer>
        <Title>Search detail page</Title>
        <Location>
          {/* {ticketData !== null && ticketData.referenceName}
          {ticketData !== null && ticketData.locationOnPlan} */}
        </Location>
      </HeadingContainer>
    </Wrapper>
    <IssuedByContainer>
      {/* <IssuedByTitle>Issued by: </IssuedByTitle>
      <IssuedBy>
        {ticketData !== null && ticketData.creatorInfo.createdBy}
      </IssuedBy> */}
    </IssuedByContainer>
  </HeaderContainer>
);

export default Header;
